import { useEffect } from "react";
import { useInvalidator } from "rest-hooks";

export const useInvalidateOnUnmount = (fetchShape: any, params: any) => {
	const invalidate = useInvalidator(fetchShape);
	useEffect(() => {
		return () => invalidate(params);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
};
